import { RefObject, useCallback } from 'react';

const useScrollToRef = (
  ref: RefObject<HTMLElement> | null,
  offset: number = 16,
  navSelector: string = 'nav.navbar',
) => {
  return useCallback(() => {
    if (ref && ref.current) {
      // Offset the scroll by the height of the navbar + the specified offset. A default of 16px
      // (1rem) is used if none is specified. If no nav is found, only the offset is used
      const navElement = document.querySelector(navSelector);
      const scrollOffset = navElement instanceof HTMLElement
        ? navElement.offsetHeight + offset
        : offset;

      window.scrollTo({
        // This method is preferable to element.offsetTop, since offsetTop can be affected by
        // positioned parents (like if a container has position: relative)
        top: ref.current.getBoundingClientRect().top + window.scrollY - scrollOffset,
        behavior: 'smooth',
      });
    }
  }, [ref, offset, navSelector]);
};

export default useScrollToRef;
